import {
  CHANGE_ACTIVE_TS_EXPERT,
  CHANGE_ACTIVE_ITEM_LIVELIST,
  CHANGE_ACTIVE_ITEM_LIVELIST_MATRIX,
  CHANGE_ACTIVE_ITEM_OSCILLOSCOPE,
  CHANGE_ACTIVE_ITEM_BAR_GRAPH,
  CHANGE_ACTIVE_ITEM_OPTIC_FIBER,
  CHANGE_ACTIVE_ITEM_OPTIC_FIBER_LOG,
  CHANGE_ACTIVE_ITEM_LOG,
  CHANGE_ACTIVE_ITEM_CONFIG,
  SOLVE_PROBLEM,
} from "../actions/types";

export function activeMenuItemReducer(initialState = { activeItem: "/" }, action) {
  switch (action.type) {
    case CHANGE_ACTIVE_TS_EXPERT:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_LIVELIST:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_LIVELIST_MATRIX:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_OSCILLOSCOPE:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_BAR_GRAPH:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_OPTIC_FIBER:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_OPTIC_FIBER_LOG:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_LOG:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_CONFIG:
      return action.payload.activeItem;
    default:
      return initialState;
  }
}

export function solveProblemReducer(initialState = { solve: false, problem: {} }, action) {
  switch (action.type) {
    case SOLVE_PROBLEM:
      return action.payload;
    default:
      return initialState;
  }
}